import { Injectable, OnDestroy, inject } from '@angular/core';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { DadosGuia, TipoGuia } from './guias.types';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class GuiaService implements OnDestroy {
    private readonly router = inject(Router);

    private readonly dadosGuias: Map<TipoGuia, DadosGuia[TipoGuia]> = new Map<TipoGuia, DadosGuia[TipoGuia]>();

    private readonly onDestroy$: Subject<void> = new Subject();

    private readonly emitter$: Subject<void> = new Subject();

    constructor() {
        this.ouvirRota();
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    public setDadosGuia(tipoGuia: TipoGuia, dadosGuia: DadosGuia[TipoGuia]): void {
        this.dadosGuias.set(tipoGuia, dadosGuia);
        this.emitter$.next();
    }

    public getDadosGuia(tipoGuia: TipoGuia): Observable<DadosGuia[TipoGuia] | null> {
        return new Observable<DadosGuia[TipoGuia] | null>((observer) => {
            observer.next(this.dadosGuias.get(tipoGuia) ?? null);
            this.emitter$
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(() => observer.next(this.dadosGuias.get(tipoGuia) ?? null));
        });
    }

    public clearDadosGuia(tipoGuia: TipoGuia): void {
        this.dadosGuias.delete(tipoGuia);
        this.emitter$.next();
    }

    public clearDadosGuiaWhen(tipoGuia: TipoGuia, predicate: (dadosGuia: DadosGuia[TipoGuia]) => boolean): void {
        const dadosGuia = this.dadosGuias.get(tipoGuia);
        if (dadosGuia && predicate(dadosGuia)) {
            this.clearDadosGuia(tipoGuia);
        }
    }

    private ouvirRota(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.onDestroy$)
            )
            .subscribe(() => this.dadosGuias.clear());
    }
}
